import React, { memo, useCallback, useMemo } from 'react'
import { NumberInput } from '../../NumberInput/index.js'
import { prettyNumber } from '@based/pretty-number'
import { capitalize, splitByUppercase } from '../../../utils/text.js'

export const NumberType = memo(
  ({
    value,
    onChange,
    schemaProp,
    type = '',
    name,
    int = true,
    disabled,
  }: any) => {
    const {
      title,
      description,
      readOnly,
      max,
      min,
      step,
      default: defaultValue,
      display,
    } = schemaProp

    const label = useMemo(
      () => capitalize(splitByUppercase(title ?? name)),
      [title, name],
    )

    const suffix = useMemo(() => {
      if (display === 'dollar') return 'USD'
      if (display === 'euro') return 'EUR'
      if (display === 'pound') return 'GBP'
      if (display === 'meter') return 'm'
      if (display === 'ratio') return '%'
      return null
    }, [display])

    const newMin = useMemo(() => {
      if (type === 'int8') return -128
      if (type === 'int16') return -32768
      if (type === 'int32') return -2147483648
      if (type === 'uint8' || type === 'uint16' || type === 'uint32') return 0
      return min
    }, [type, min])

    const newMax = useMemo(() => {
      if (type === 'int8') return 127
      if (type === 'int16') return 32767
      if (type === 'int32') return 2147483647
      if (type === 'uint8') return 255
      if (type === 'uint16') return 65535
      if (type === 'uint32') return 4294967295
      return max
    }, [type, max])

    const placeholder = useMemo(() => {
      const base = value ?? defaultValue
      if (!readOnly) return base
      if (display === 'bytes') return prettyNumber(base, 'number-bytes')
      if (display === 'short') return prettyNumber(base, 'number-short')
      return base
    }, [value, defaultValue, readOnly, display])

    const handleChange = useCallback(
      (v: any) => {
        onChange?.(v, name)
      },
      [onChange, name],
    )

    return (
      <NumberInput
        int={int}
        value={value ?? ''} // ✅ não quebra 0
        onChange={handleChange}
        label={label}
        description={description}
        max={newMax}
        min={newMin}
        step={step}
        disabled={readOnly || disabled}
        suffix={suffix}
        placeholder={placeholder}
      />
    )
  },
  (prev, next) =>
    prev.value === next.value &&
    prev.disabled === next.disabled &&
    prev.int === next.int &&
    prev.type === next.type &&
    prev.name === next.name &&
    prev.onChange === next.onChange &&
    prev.schemaProp === next.schemaProp,
)
